import { Checkbox, FormField, Input, Table, Toggle } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import { useEffect, useMemo, useState } from 'react';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';
import { CustomAppLayout } from '../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiAccountMultiple, mdiCheckCircle, mdiDeleteAlert, mdiLightbulbOn, mdiLightbulbOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { useGlobalState } from '../../../context/GlobalStateContext';


export const MasterCharges = () => {

    type ItemAccountPlan = {
        idAccountPlan: number;
        users: number;
        isActiveAccountPlan: number;
        isDeleteAccountPlan: number;
        isCostCenter: number;
        isAux: number;
        accountPlan: string;
        codeAccountPlan: string;
        codeAccountPlanSoftland: string;
        CCO: string;

    }

    type ItemCharge = {
        idCharge: number,
        users: number,
        isActiveCharge: number,
        isDeleteCharge: number,
        ammount: number,
        currency: string,
        charge: string,
        accountPlan: string,
        account: string,
        isPAC: number,
    };


    const { menu, parameters } = useGlobalState();
    const [sideOpen, setSideOpen] = useState(false);
    const [showInactives, setShowInactives] = useState(false);
    const [showDeleted, setShowDeleted] = useState(false);
    const [activeTab, setActiveTab] = useState('charges');


    const [charges, setCharges] = useState<ItemCharge[]>([])
    const [filteringText, setFilteringText] = useState("")

    const filtered = useMemo(() => {
        //if (!filterAccountsPlans.trim()) return accountPlans;
        let filtered = charges;
        if (!showDeleted) {
            filtered = filtered.filter(item => item.isDeleteCharge === 0);
        }

        // ✅ Handle Inactive filter
        if (!showInactives) {
            filtered = filtered.filter(item => item.isActiveCharge === 1);

        }
        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            filtered = filtered.filter(item => {
                const haystack = [
                    item.charge ?? "",
                    item.currency ?? "",
                    item.ammount.toString(),
                    item.idCharge.toString(),
                ].join(" ").toLowerCase();

                return terms.every(term => haystack.includes(term));
            });
        }

        return filtered;
    }, [charges, filteringText, showDeleted, showInactives]);

    const [currentPageIndex, setCurrentPageIndex] = useState(1)
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    const handleGetCharges = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/charges/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.charges)
                setCharges(data.charges)
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdateCharge = async (body: any) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/charges/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(body)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.charges)
                setCharges(data.charges)
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === "accountPlans") {
            //handleGetCharges();
        }

    }, [activeTab]);
    useEffect(() => {
        handleGetCharges()
    }, []);
    //
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                            counter={filteringText === "" ? charges.length ? `(${charges.length})` : "" : `${filtered.length} de ${charges.length}`}
                        >Cargos</Header>

                        <Table<ItemCharge>
                            stickyHeader
                            variant="embedded"
                            items={paginated}
                            filter={
                                <FormField
                                    constraintText={
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <Checkbox checked={showInactives} onChange={(event) => setShowInactives(event.detail.checked)}>Mostrar inactivos</Checkbox>
                                            <Checkbox checked={showDeleted} onChange={(event) => setShowDeleted(event.detail.checked)}>Mostrar eliminados</Checkbox>
                                        </SpaceBetween>
                                    }
                                >
                                    <TextFilter
                                        filteringText={filteringText}
                                        filteringPlaceholder="Buscar..."
                                        onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                    />
                                </FormField>
                            }

                            pagination={



                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {charges.length > 0 && (

                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>

                            }

                            submitEdit={async (item, column, newValue) => {
                                console.log(item, column, newValue)
                                const body = { idCharge: item.idCharge, [column.id]: newValue }

                                handleUpdateCharge(body)
                                // Example: update backend
                                // await api.update(item.id, {[column.id]: newValue });
                            }}
                            columnDefinitions={[
                                {
                                    id: "idCharge", header: "ID", cell: item => item?.idCharge,
                                    width: 70
                                },
                                {
                                    id: "charge", header: "Cargo", cell: item => item?.charge,

                                    editConfig: {
                                        ariaLabel: "Name",
                                        editIconAriaLabel: "editable",
                                        errorIconAriaLabel: "Name Error",

                                        editingCell: (
                                            item,
                                            { currentValue, setValue }
                                        ) => {
                                            return (
                                                <Input
                                                    autoFocus={true}
                                                    value={currentValue ?? item.charge}
                                                    onChange={event => {
                                                        setValue(event.detail.value)
                                                    }}
                                                />
                                            );
                                        },
                                    }
                                },
                                {
                                    id: "ammount", header: "Valor", cell: item => `${Number(item?.ammount ?? 0).toLocaleString("es-CL")} ${item?.currency ?? ""}`,
                                    editConfig: {
                                        ariaLabel: "Name",
                                        editIconAriaLabel: "editable",
                                        errorIconAriaLabel: "Name Error",

                                        editingCell: (
                                            item,
                                            { currentValue, setValue }
                                        ) => {
                                            return (
                                                <Input type='number'
                                                    autoFocus={true}
                                                    value={currentValue ?? item.ammount}
                                                    onChange={event => {
                                                        setValue(event.detail.value)
                                                    }}
                                                />
                                            );
                                        },
                                    }
                                },
                                {
                                    id: "isPAC", header: "PAC",
                                    cell: item => (
                                        <>
                                            {item.isPAC === 1 ? <Icon path={mdiCheckCircle} size={1} /> : ""}
                                        </>
                                    ),

                                    editConfig: {
                                        ariaLabel: "Name",
                                        editIconAriaLabel: "editable",
                                        errorIconAriaLabel: "Name Error",

                                        editingCell: (
                                            item,
                                            { currentValue, setValue }
                                        ) => {
                                            return (
                                                <Toggle
                                                    onChange={({ detail }) =>
                                                        setValue(detail.checked ? 1 : 0)
                                                    }
                                                    checked={currentValue ?? item.isPAC === 1}
                                                />
                                            );
                                        },
                                    }
                                },
                                {
                                    id: "isActiveCharge", header: "",
                                    width: 50,
                                    cell: item => (

                                        <>
                                            {item.isActiveCharge === 1 ?
                                                <Icon path={mdiLightbulbOn} color={"#f7c302"} size={1} /> :
                                                <Icon path={mdiLightbulbOutline} color={"#ddd"} size={1} />
                                            }
                                        </>
                                    )
                                },
                                {
                                    id: "isDeleteCharge", header: "",
                                    width: 50,
                                    cell: item => (

                                        <>
                                            {item.isDeleteCharge === 1 ? <Icon path={mdiDeleteAlert} color={"red"} size={1} /> : ""}
                                        </>
                                    )
                                },
                                {
                                    id: "users", header: <Icon path={mdiAccountMultiple} size={1} />,
                                    width: 50,
                                    cell: item => (
                                        item.users
                                    )
                                },
                            ]}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin cargos según criterios</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                    </SpaceBetween>

                </>
            }
        />
    );
};